import { TourCategoryModel } from 'api-hooks/tour-category';
import React from 'react';

import { TourCategoryFormType } from '../components/form-type';

export default function useTourCategoryDefaultValues(
  tourCategory?: TourCategoryModel,
): TourCategoryFormType {
  const defaultValues = React.useMemo<TourCategoryFormType>(() => {
    return {
      name: tourCategory?.name || '',
      description: tourCategory?.description || '',
      adminCommission:
        tourCategory?.adminCommission || ('' as unknown as number),
      operatorCommission:
        tourCategory?.operatorCommission || ('' as unknown as number),
      salesCommission:
        tourCategory?.salesCommission || ('' as unknown as number),
      tourCategory,
    };
  }, [tourCategory]);
  return defaultValues;
}
